import React from "react";
import { Container } from "react-bootstrap";

const OsenveltHCP = ({ shouldHideDiv, collapseText, isiTextRef, readLess }) => {
  return (
    <>
      <div
        className={`isi-text-sticky isi-text ${shouldHideDiv ? "d-none" : ""}`}
      >
        <Container className="position-relative">
          <div className="isi-text-wrap responsive-flex">
            <button className="isi-text-open open osenvelt" onClick={collapseText}>              
            </button>
            <div style={{paddingRight:"40px"}}>
              <br />
              <p>
                <strong className="osenvelt-color">
                  IMPORTANT SAFETY INFORMATION
                </strong>
              </p>
              <p>
                If you receive Osenvelt, you should not receive other denosumab
                products at the same time.
              </p>
              <p>
                <strong>
                  Osenvelt can cause serious side effects including:
                </strong>
              </p>
              <p>
                <strong>
                  Increased risk of severe low calcium levels in your blood
                  (hypocalcemia).
                </strong>
                &nbsp; Osenvelt may lower the calcium levels in your blood. Your
                doctor should treat any low calcium levels before starting
                Osenvelt and may prescribe calcium and vitamin D
                supplements—take these exactly as instructed. If you have
                advanced chronic kidney disease (with or without dialysis) or
                chronic kidney disease-mineral bone disorder (CKD-MBD), your
                risk of severe hypocalcemia increases, potentially leading to
                hospitalization, life-threatening events, or death. Your doctor
                may monitor your blood levels before and during treatment. Low
                blood calcium often has no symptoms, but call your doctor
                immediately if you notice muscle spasms, twitches, cramps, or
                numbness and tingling in your fingers, toes, or around your
                mouth.
              </p>
            </div>
            <div style={{paddingRight:"40px"}}>
              <br />
              <p>
                <strong className="osenvelt-color">INDICATIONS</strong>
              </p>
              <p>
                Osenvelt (denosumab-bmwo) is a prescription medicine used to:
                <ul>
                  <li>
                    Help prevent bone complications in patients with multiple
                    myeloma and in patients whose cancer from solid tumors has
                    spread to the bones.
                  </li>
                  <li>
                    Treat adults and adolescents (whose bones have stopped
                    growing) with giant cell tumor of bone that cannot be
                    removed with surgery, or when surgery could cause severe
                    complications.
                  </li>
                  <li>
                    Treat high blood calcium caused by cancer (hypercalcemia of
                    malignancy) that has not improved after treatment with
                    bisphosphonates.
                  </li>
                </ul>
              </p>
            </div>
          </div>
        </Container>
      </div>

      <div className="isi-text" ref={isiTextRef}>
        <Container className="position-relative">
          <div className="isi-text-wrap responsive-flex">
            <button onClick={readLess} className="isi-text-open closed osenvelt">
              
            </button>
            <div style={{paddingRight:"40px"}}>
              <br />
              <p>
                <strong className="osenvelt-color">
                  IMPORTANT SAFETY INFORMATION
                </strong>
              </p>
              <p>
                If you receive Osenvelt, you should not receive other denosumab
                products at the same time.
              </p>
              <p>
                <strong>
                  Osenvelt can cause serious side effects including:
                </strong>
              </p>
              <p>
                <strong>Serious allergic reactions.</strong> Serious allergic
                reactions have occurred with denosumab products. Call your
                doctor or seek emergency care immediately if you experience
                symptoms such as low blood pressure (hypotension), rash,
                difficulty breathing, itching, throat tightness, hives, or
                swelling of your face, lips, or tongue.
              </p>
              <p>
                <strong>Low blood calcium (Hypocalcemia).</strong> Osenvelt can
                lower your blood calcium levels, which can become severe or even
                life-threatening. Your doctor will check your calcium levels
                before and during treatment, especially in the first few weeks.
                You may need to take calcium, magnesium, and vitamin D
                supplements as instructed by your doctor. Your risk may be
                higher if you have kidney problems or take other medicines that
                lower blood calcium. Call your doctor immediately if you
                experience symptoms of low blood calcium, such as muscle spasms
                or cramps, numbness or tingling in fingers, toes, or around your
                mouth, twitching or stiffness.
              </p>
              <p>
                <strong>Severe jawbone problems (osteonecrosis).</strong> Severe
                jaw bone problems may happen when you take Osenvelt. Your doctor
                should examine your mouth before starting treatment and may
                advise seeing a dentist. Practice good oral care and consult
                your doctor or dentist if needed.
              </p>
              <p>
                <strong>Unusual thigh bone fractures.</strong> Symptoms include
                new or unusual pain in your hip, groin, or thigh.
              </p>
              <p>
                <strong>High Blood Calcium After Stopping Treatment.</strong> If
                you have giant cell tumor of bone or are still growing, stopping
                Osenvelt can lead to high calcium levels in your blood
                (hypercalcemia). This condition can become severe, require
                hospitalization, and affect your kidneys. Your doctor will
                monitor your calcium levels after stopping treatment. Call your
                doctor right away if you notice symptoms of high blood calcium,
                such as nausea or vomiting, increased thirst or urination,
                confusion or tiredness, muscle weakness or pain. Follow your
                doctor's instructions carefully, and keep all scheduled
                appointments for calcium monitoring.
              </p>
              <p>
                <strong>
                  Multiple Spine Fractures After Stopping Osenvelt.
                </strong>{" "}
                After stopping treatment with Osenvelt, some patients have
                experienced multiple spine fractures. Your risk is higher if you
                have osteoporosis, previous fractures, or other risk factors.
                Your doctor will assess your individual fracture risk when
                stopping Osenvelt.
              </p>
              <p>
                <strong>Risk to Unborn Babies. </strong>Osenvelt may harm your
                unborn baby if you take it while pregnant or within 5 months
                before becoming pregnant. Animal studies have shown serious
                harm, including pregnancy loss, birth defects, abnormal bone
                growth, missing lymph nodes, and slow growth after birth. Your
                doctor will check if you are pregnant before starting Osenvelt.
                Tell your doctor immediately if you become pregnant or think you
                may be pregnant during treatment.
              </p>

              <p>
                <strong>Do not take Osenvelt</strong> if you have low blood
                calcium, are pregnant or planning pregnancy, or if you’re
                allergic to denosumab or any ingredients in Osenvelt.
              </p>
              <p>
                <strong>
                  Before taking Osenvelt, tell your doctor if you:
                </strong>
              </p>
              <ul>
                <li>take other denosumab products</li>
                <li>have low blood calcium</li>
                <li>cannot take daily calcium and vitamin D supplements</li>
                <li>take medicines that can lower blood calcium</li>
                <li>plan dental surgery or tooth removal</li>
                <li>
                  are pregnant, planning pregnancy, or breastfeeding. Osenvelt
                  may harm an unborn baby; a pregnancy test is required before
                  treatment; use effective birth control during treatment and
                  for 5 months after your last dose; inform your doctor
                  immediately if pregnancy occurs. It is unknown if Osenvelt
                  passes into breast milk; do not breastfeed during treatment.
                </li>
              </ul>
              <p>
                <p>
                  <strong>
                    Tell your doctor of all medicines, vitamins, and herbal
                    supplements you take.
                  </strong>{" "}
                  Keep an updated list to share with healthcare providers.
                </p>

                <p>
                  <strong>The most common side effects of Osenvelt are:</strong>
                </p>

                <p>
                  <strong>
                    For patients with Bone Metastasis from Solid Tumors:
                  </strong>{" "}
                  fatigue or weakness, low phosphate levels, and nausea.
                </p>

                <p>
                  <strong>For patients with Multiple Myeloma:</strong> diarrhea,
                  low phosphate, nausea, fatigue, low calcium, shortness of
                  breath, and anemia.
                </p>

                <p>
                  <strong>For patients with Giant Cell Tumor of Bone:</strong>{" "}
                  joint pain, headache, nausea, back pain, fatigue, and pain in
                  arms or legs.
                </p>
                <p>
                  <strong>
                    For patients with Hypercalcemia of Malignancy:
                  </strong>{" "}
                  nausea, trouble breathing, decreased appetite, and headache.
                </p>

                <p>
                  Tell your doctor if side effects are bothersome or persistent.
                  These are not all possible side effects. Call your doctor for
                  advice on side effects or report them to the FDA at
                  1-800-FDA-1088.
                </p>
              </p>
            </div>
            <div style={{paddingRight:"40px"}}>
              <br />
              <p>
                <strong className="osenvelt-color">INDICATIONS</strong>
              </p>
              <p>
                Osenvelt (denosumab-bmwo) is a prescription medicine used to:
                <ul>
                  <li>
                    Help prevent bone complications in patients with multiple
                    myeloma and in patients whose cancer from solid tumors has
                    spread to the bones.
                  </li>
                  <li>
                    Treat adults and adolescents (whose bones have stopped
                    growing) with giant cell tumor of bone that cannot be
                    removed with surgery, or when surgery could cause severe
                    complications.
                  </li>
                  <li>
                    Treat high blood calcium caused by cancer (hypercalcemia of
                    malignancy) that has not improved after treatment with
                    bisphosphonates.
                  </li>
                </ul>
              </p>
            </div>
          </div>
        </Container>
      </div>
    </>
  );
};

export default OsenveltHCP;
